<template>
  <div class="pt-2">
    <div class="row">
      <div class="flex xs12 md6">
        <div
          class="title mb-3"
          :style="computedStylesTitle"
        >
          {{$t('dashboard.tabs.billingAddress.personalInfo')}}
        </div>
        <va-input
          :label="$t('dashboard.tabs.billingAddress.firstName')"
          v-model="form.name"
          :readonly = "true"
        />
        <va-input
          :label="$t('dashboard.tabs.billingAddress.email')"
          v-model="form.email"
          :readonly = "true"
        />
        <va-input
          :label="$t('dashboard.tabs.billingAddress.id_no')"
          v-model="form.id_no"
          :readonly = "true"
        />
        <va-input
          :label="$t('dashboard.tabs.billingAddress.phone_no')"
          v-model="form.phone_no"
          :readonly = "true"
        />
      </div>
      <div class="flex xs12 md6">
        <div
          class="title mb-3"
          :style="computedStylesTitle"
        >
          {{$t('dashboard.tabs.billingAddress.saccoInfo')}}
        </div>
        <va-input
          :label="$t('dashboard.tabs.billingAddress.member_no')"
          v-model="form.member_no"
          :readonly = "true"
        />
        <!-- <va-checkbox
          :label="$t('dashboard.tabs.billingAddress.infiniteConnections')"
          v-model="form.connection"
        /> -->
      </div>
    </div>
    <!-- <div class="row justify--center">
      <va-button @click="submit">
        {{$t('dashboard.tabs.billingAddress.addConnection')}}
      </va-button>
    </div> -->
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'billing-address-tab',
  data () {
    return {
      form: {
        name: '',
        email: '',
        id_no: '',
        phone_no: '',
        member_no: '',
        country: '',
        connection: true,
      },
    }
  },
  methods: {
    submit () {
      this.$emit('submit', this.form)
    },
  },
  computed: {
    computedStylesTitle () {
      return {
        color: this.$themes.dark,
      }
    },
  },

  created () {
    this.userData = JSON.parse(localStorage.getItem('LoggedUser'))
    this.form.name = this.userData.full_name
    this.form.email = this.userData.user_email
    this.form.email = this.userData.user_email
    this.form.id_no = this.userData.id_number
    this.form.phone_no = this.userData.mobile_number
    this.form.member_no = this.userData.member_number
  },
}
</script>
